import type { GameV1, Real } from '@/api/games';
import {
  type IErrorHotAndColdEvent,
  sendErrorHotAndColdEvent,
} from '@/modules/googleAnalytics/events/gamesEvents';

export type GameFromStatistic = {
  title: string;
  demo: boolean;
  payout: string;
  rank: number;
  identifier: string;
  provider: string;
  seo_title: string;
  hot?: boolean;
  cold?: boolean;
  currencies?: Real;
  categories?: string[];
};

export const convertStatisticGames = (
  games?: GameFromStatistic[]
): GameV1[] => {
  if (!(games && games.length)) {
    return [];
  }

  return games.map((g) => ({
    id: g.identifier,
    fullPath: `${g.provider}/${g.seo_title}`,
    seoPath: g.seo_title,
    seoTitle: g.seo_title,
    listCollections: g.categories || [],
    categories: g.categories || [],
    currencies: g.currencies || {},
    title: g.title,
    provider: g.provider,
    collections: {},
    real: g.currencies || {},
    payout: g.payout,
    hot: g.hot,
    cold: g.cold,
  }));
};

export const sortHotAndColdLobby = (
  hotGames: GameV1[],
  coldGames: GameV1[],
  chunkSize: number
): GameV1[] => {
  const result: GameV1[] = [];
  let hotIndex = 0;
  let coldIndex = 0;
  let isHotTurn = true;

  while (hotIndex < hotGames.length || coldIndex < coldGames.length) {
    if (isHotTurn) {
      const chunk = hotGames.slice(hotIndex, hotIndex + chunkSize);
      if (chunk.length > 0) {
        result.push(...chunk);
        hotIndex += chunkSize;
      }
    } else {
      const chunk = coldGames.slice(coldIndex, coldIndex + chunkSize);
      if (chunk.length > 0) {
        result.push(...chunk);
        coldIndex += chunkSize;
      }
    }

    isHotTurn = !isHotTurn;
  }

  return result;
};

export const handleErrorHotAndColdEvent = (
  noHotGames: boolean,
  noColdGames: boolean
) => {
  let type: IErrorHotAndColdEvent['type'] | null = null;

  if (noHotGames && noColdGames) {
    type = 'no_both';
  } else if (noHotGames) {
    type = 'no_hot';
  } else if (noColdGames) {
    type = 'no_cold';
  }

  if (type) sendErrorHotAndColdEvent({ type });
};
